module.exports = ".GreenForLogin {\r\n  color: White !important;\r\n  background: #336699 !important;\r\n  border: medium none !important;\r\n}\r\n\r\n  .GreenForLogin:hover {\r\n    background: #274B63 !important;\r\n    color: White !important;\r\n  }\r\n\r\n  .MaxResolutionCenter {\r\n  float: none;\r\n  margin: 0 auto;\r\n  max-width: 2000px;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/Login/Login.css
// module id = ./src/app/Login/Login.css
// module chunks = main